import { render, staticRenderFns } from "./form_item.vue?vue&type=template&id=6244e6ea&scoped=true&"
import script from "./form_item.vue?vue&type=script&lang=js&"
export * from "./form_item.vue?vue&type=script&lang=js&"
import style0 from "./form_item.vue?vue&type=style&index=0&id=6244e6ea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6244e6ea",
  null
  
)

export default component.exports